import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpCancelService } from '@services/http-cancel/http-cancel.service';
import { profilePictureUrl } from '@services/contract/contract.service';
import { notificationUrl } from '@services/notification/notification.service';
@Injectable()
export class HttpCancelInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private httpCancelService: HttpCancelService
  ) {
    router.events.subscribe(event => {
      // An event triggered at the end of the activation part of the Resolve phase of routing.
      if (event instanceof ActivationEnd) {
        // Cancel pending calls
        this.httpCancelService.cancelPendingRequests();
      }
    });
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (
      request.url.includes(notificationUrl) ||
      request.url.includes(profilePictureUrl) ||
      request.url.includes('assets/i18n/')
    ) {
      return next.handle(request);
    }
    return next
      .handle(request)
      .pipe(takeUntil(this.httpCancelService.onCancelPendingRequests()));
  }
}
